module.exports = __webpack_public_path__ + "static/media/thumbnail.cce70eaf.jpg";